// @flow

import React from 'react';
import styled from 'styled-components';

import Link from './Link';
import { VisuallyHidden } from 'components/Global/Aria';
import type { LinkProps } from './Link';
import { FOOTER_DISCLAIMER_SECTIONS, LIGHT_DARK } from 'Constants';
import type { LightDark } from 'Constants';
import { Color, Fonts } from 'styles';

const Sup = styled.sup`
  vertical-align: top;
  display: inline-block;
  transform: translateY(-0.15em);
  ${Fonts.GOTHIC};
  font-size: 0.65em;
  color: ${({ theme }) => (theme === LIGHT_DARK.LIGHT ? Color.BLACK_SOUL : Color.WHITE)};
`;

type Props = {
  numIndex?: number,
  footerSection?: $Keys<typeof FOOTER_DISCLAIMER_SECTIONS>,
  elementId?: string,
  theme?: LightDark,
};

const SupLink = ({ theme = LIGHT_DARK.LIGHT, footerSection, numIndex, elementId = '', children, ...rest }: Props & LinkProps) => (
  <Link
    url={
      footerSection && typeof numIndex !== 'undefined' ? `#${FOOTER_DISCLAIMER_SECTIONS[footerSection]}${numIndex}` : `#${elementId}`
    }
    {...rest}>
    <Sup theme={theme}>
      {footerSection && footerSection === 'numbered' ? numIndex : children}
      <VisuallyHidden hiddenText="navigates to the related disclosure" />
    </Sup>
  </Link>
);

export default SupLink;
